import RFFInputField from '../../form/RFFInputField';
import RFFSelectField from '../../form/RFFSelectField';
import {
  // isNationalStockNumber,
  // isNationalItemIdentificationNumber,
  composeValidatorsForNonRequired,
  isCageCode,
  required,
  isNSNorNIIN,
} from '../../../utils/validationUtils';



export default [
  {
    id: 'partNum',
    name: 'partNum',
    label: 'Part No',
    placeholder: 'Required Field',
    component: RFFInputField,
    isRequired: true,
    validate: required,
    disabled: true,
  },
  {
    id: 'niin',
    name: 'niin',
    label: 'NIIN',
    placeholder: 'NIIN ( Last 9 digits of the NSN)',
    component: RFFInputField,
    validate: isNSNorNIIN,
    maxlength: 128,
    disabled: true,
  },
  {
    id: 'description',
    name: 'description',
    label: 'Description',
    placeholder: 'optional',
    component: RFFInputField,
    maxlength: 50,
  },
  {
    id: 'toolingRef',
    name: 'toolingRef',
    label: 'Tooling Ref',
    placeholder: 'optional',
    component: RFFInputField,
    maxlength: 50,
  },
  {
    id: 'ownerCage',
    name: 'ownerCage',
    label: 'Tooling Cage',
    placeholder: 'optional',
    component: RFFInputField,
    validate: composeValidatorsForNonRequired(isCageCode),
  },
  {
    id: 'designAlloy',
    name: 'designAlloy',
    label: 'Design Alloy',
    placeholder: 'optional',
    component: RFFInputField,
    maxlength: 50,
  },
  {
    id: 'comments',
    name: 'comments',
    label: 'Comments',
    placeholder: 'optional',
    component: RFFInputField,
    maxlength: 200,
  },
  {
    id: 'accessLevel',
    name: 'accessLevel',
    label: 'Visibility',
    component: RFFSelectField,
    isRequired: true,
    placeholder: 'Access Level',
  },
  {
    id: 'category',
    name: 'category',
    label: 'Category',
    component: RFFSelectField,
    isRequired: true,
    placeholder: 'Category',
  },
];



// WEBPACK FOOTER //
// ./src/components/forms/AddToolingForm/formConfig.jsx